module.exports = __webpack_public_path__ + "img/1647b79.png";